
import {$obj} from "@util/util.js";

export default class DefineProperty{
    constructor(data){
        this._data = data;

        this._arrMethods = ['push','pop','shift','unshift','splice','sort'];
        //创建新的对象，当前对象保留Array的原型
        this._arrProperty = Object.create(Array.prototype);
    }

    replaceArrayProperty(){
        let that = this;
        this._arrMethods.forEach(item=>{
            let origin = Array.prototype[item];
            this._arrProperty[item] = function(){
                let res = origin.apply(this, arguments);
                that.listenerArray(this);
                return res;
            }
        })   
    }

    listenerArray(array){
        for (let index = 0; index < array.length; index++) {
            new DefineProperty(array[index]).run();
        }
    }

    run(){
        let val = null;
        for(let i in this._data){
            val = this._data[i];
            if(typeof val === "object"){
                if(Array.isArray(val)){
                    if(!$obj.isEqual(val.__proto__, this._arrProperty)){
                        val.__proto__ = this._arrProperty;
                    }
                    this.listenerArray(val);
                }
                new DefineProperty(val).run();
            }
            this.listener(i, val);
        }
    }

    listenerField(key, cb){
        let value = this._data[key];
        Object.defineProperty(this._data, key ,{
            get(){
                return value;
            },
            set(val){
                if(val == value){
                    // console.log(`${key} is the same:${value}`);
                }else{
                    value = val;
                    cb && cb(value);
                }
            }
        })
    }

    listener(key, value){
        Object.defineProperty(this._data, key ,{
            get(){
                return value;
            },
            set(val){
                if(val == value){
                    return;
                }else{
                    value = val;
                }
            }
        })
    }

    init(){
        this.replaceArrayProperty();
        return this;
    }
}